<template>
  <i class="bi" :class="`bi-${icon}`"></i>
</template>

<script>
export default {
  name: "Icon",
  props: {
    icon: {
      default: ''
    }
  }
}
</script>

<style scoped>
.bi::before{

  vertical-align: -4px !important;

}
</style>